module.exports = __webpack_public_path__ + "static/media/data-analyst-feature-3.2fc2e2cc.svg";